module.exports = __webpack_public_path__ + "img/shape_1329.35d82dcb.png";